export function createOptionsFromEnum<
  Enum extends Record<string | number, string>,
  EnumLabelMap extends Record<keyof Enum, string>
>(e: Enum, enumLabelMap: EnumLabelMap): { label: string; value: string }[] {
  return Object.entries(enumLabelMap).map(([value, label]) => ({
    label,
    value
  }));
}
